// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionWebsite_root__27Z7s","list":"SectionWebsite_list__e_oAo"};